module.exports = __webpack_public_path__ + "img/27000.4cf2ce08.jpg";